/**
 * This is the column used in the performance contribution table and ranking table
 */
export enum PerformanceContributionColumn {
  /**
   * the first column in PerformanceContributionTableType.CONTRIBUTION/PerformanceContributionTableType.BENCHMARK,
   * only used in `PerformanceContributionBreakdown`
   */
  FILTER = 'filter',

  /**
   * the first column in PerformanceContributionTableType.RANKING, only used in `TopBottom10Table`
   */
  STRATEGY = 'strategy',

  AVERAGE_WEIGHT = 'averageWeight',
  AVERAGE_GROSS_WEIGHT = 'averageGrossWeight',
  TOTAL_CONTRIBUTION = 'totalContribution',
  /**
   * Only used by HSBC
   */
  EFFECTIVE_RETURN = 'effectiveReturn',
  EFFECTIVE_GROSS_RETURN = 'effectiveGrossReturn',
  CUMULATIVE_RETURN = 'cumulativeReturn',
}

export type PerformanceContributionHighlightedMetric = Exclude<
  PerformanceContributionColumn,
  PerformanceContributionColumn.FILTER | PerformanceContributionColumn.STRATEGY
>;

export type PerformanceContributionRankingTableColumn = Exclude<
  PerformanceContributionColumn,
  PerformanceContributionColumn.FILTER | PerformanceContributionColumn.EFFECTIVE_GROSS_RETURN
>;

export type PerformanceContributionByGroupFilterTableColumn = Exclude<
  PerformanceContributionColumn,
  PerformanceContributionColumn.STRATEGY
>;

/**
 * Settings type for PerformanceContributionTable.
 * sortMetric may be any column the table can emit.
 */
export type PerformanceContributionTableSettings = {
  highlightedMetric: PerformanceContributionHighlightedMetric;
  sortMetric: PerformanceContributionColumn;
  sortOrder: 1 | -1;
};
